import {blobToBase64} from '@legit-health/ui';
import type {FormValues} from '../interfaces';

interface BodyPartImage {
  image: {
    image: string;
    x: number;
    y: number;
    width: number;
    height: number;
  };
  bodySite: string;
}

export default async function mapFormValuesToApiFormat(
  images: FormValues
): Promise<BodyPartImage[]> {
  const bodyPartImages: BodyPartImage[] = [];

  for (const bodySite in images) {
    const image = images[bodySite as keyof FormValues];
    if (!image.file || !image.crop) {
      throw new Error(`Invalid values for ${bodySite}`);
    }

    const {crop, file, base64} = image;
    const base64Image = base64 ?? (await blobToBase64(file));

    bodyPartImages.push({
      image: {
        image: base64Image,
        x: crop.x,
        y: crop.y,
        width: crop.width,
        height: crop.height
      },
      bodySite
    });
  }

  return bodyPartImages;
}
